import './css/App.css';
import MainBlock from './Navigation/MainBlock';

function App() {
  return (
    <div className="App">
      <MainBlock></MainBlock>
    </div>
  );
}

export default App;
